import request from '@/utils/request'
const api1 = process.env.VUE_APP_BASE_API1;
const url1 = (path) => api1 + path;

export function addCallNumber(data) {
    //新增呼叫中心号码
    return request({
      url: url1('/seat/addCallNumber'),
      method: 'post',
      data:data,
    });
  }

export function fetchCallNumber(query) {
  //呼叫中心号码列表
  return request({
    url: url1('/seat/getCallNumberList'),
    method: 'get',
    params: query,
  });
}

export function addContact(data) {
  //新增小度联系人
  return request({
    url: url1('/seat/addContact'),
    method: 'post',
    data:data,
  });
}

export function updateContact(data) {
    //修改小度联系人信息
    return request({
      url: url1('/seat/updateContactInfo'),
      method: 'post',
      data:data,
    });
  }

  
export function deleteContact(query) {
    //删除小度联系人
    return request({
      url: url1('/seat/deleteContact'),
      method: 'post',
      params: query,
    });
}

export function fetchContactInfo(query) {
    //小度联系人信息
    return request({
      url: url1('/seat/contactInfo'),
      method: 'get',
      params: query,
    });
}

export function fetchContact(query) {
    //小度联系人列表
    return request({
      url: url1('/seat/contactList'),
      method: 'get',
      params: query,
    });
}

export function assignedCallNumber(data) {
    //分配呼叫中心号码
    return request({
      url: url1('/seat/assignedCallNumber'),
      method: 'post',
      params: data,
    });
}
  
export function seatMount(data) {
    //坐席挂载
    return request({
      url: url1('/seat/seatMount'),
      method: 'post',
      data:data,
    });
}

export function fetchSeatAccount(query) {
    //坐席账号列表
    return request({
      url: url1('/seatAccount'),
      method: 'get',
      params: query,
    });
}

export function fetchDeviceCallInfo(query) {
  //小度设备呼叫信息
  return request({
    url: url1('/equipment/xiaoduCallInfo'),
    method: 'post',
    params: query,
  });
}

export function fetchSeatAccountInfo(query) {
  //坐席账号信息
  return request({
    url: url1('/seat/seatAccountInfo'),
    method: 'get',
    params: query,
  });
}

export function fetchNotAssociatedDevice(query) {
  //联系人未关联设备
  return request({
    url: url1('/seat/notAssociatedDeviceList'),
    method: 'get',
    params: query,
  });
}

export function contactAssociatedDevice(data) {
  //联系人关联设备
  return request({
    url: url1('/seat/contactAssociatedDevice'),
    method: 'post',
    data:data,
  });
}

export function fetchXiaoduCallRecord(query) {
  //小度通话记录
  return request({
    url: url1('/seat/getPageXiaoduCallRecord'),
    method: 'get',
    params: query,
  });
}